export default __webpack_public_path__ + "static/media/brief.760b7424.webp";